export const findaDoctor = () => {
	var callouts = $('.css--finddoctor-sidebar');
	
	callouts.each(function(index, item){
		var $item = $(item);
		var zipcodeInput = $item.find('#zipcode-input');
		var hdnSpecialty = $item.find('#hdn-specialty');
		var zipcodeBtn = $item.find('#zipcode-button');
		var selectedSpecialty = $item.find('.css--superhero__dropdown-list > .active');
		
		if (hdnSpecialty.val()) {
            params.filter = formatSpecialty(hdnSpecialty.val());
        } else if (selectedSpecialty.length > 0 && selectedSpecialty[0].innerHTML) {
			params.filter = formatSpecialty(selectedSpecialty[0].innerHTML);
		}
		
		zipcodeBtn.on("click", function (e) {
			e.preventDefault();
			var params = {};
			
			var selectedSpecialty = $item.find('.css--superhero__dropdown-list > .active');
			if (hdnSpecialty.val()) {
				params.filter = formatSpecialty(hdnSpecialty.val());
			} else if (selectedSpecialty.length > 0 && selectedSpecialty[0].innerHTML) {
				params.filter = formatSpecialty(selectedSpecialty[0].innerHTML);
			}
			
			var zipcode = zipcodeInput.val();
			if (zipcode) {
				getGeoFromZipcode(params, zipcode)
			} else{
				search(params);
			}
		});
		
		var max_chars = 5;
		zipcodeInput.keydown(function(e){
			if ($(this).val().length >= max_chars) { 
				$(this).val($(this).val().substr(0, max_chars));
			}
		});

		zipcodeInput.keyup( function(e){
			if ($(this).val().length >= max_chars) { 
				$(this).val($(this).val().substr(0, max_chars));
			}
		});
	});
	
	function search(params){
        var redirectUrl = "https://directory.trihealthpho.com/search"       
		if (!jQuery.isEmptyObject(params)) {
			redirectUrl += "?" + $.param(params);
		}

		window.location.href = redirectUrl;
	}
	
	function formatSpecialty(specialty){
		return "specialties.specialty.untouched:" + specialty;
	}
	
	function getGeoFromZipcode(params, zipcode) {
		
        var GOOGLE_MAP_KEY = "AIzaSyDFMwCicJvIyvdz6cUv4xYGXui6iUi5xlY";

        $.ajax('https://maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + GOOGLE_MAP_KEY)
            .then(
                function success(response) {
					if (response.results.length > 0 && response.results[0].geometry.location){						
						params.display_location = encodeURIComponent(zipcode);
						params.sort = "distance";
						params.location = response.results[0].geometry.location.lat + "," + response.results[0].geometry.location.lng;
						
						search(params);
					} else{
						console.log("Unable to retrieve coordinates for " + zipcode);
					}
				},                

                function fail(status) {
                    console.log('Request failed. Returned status of', status)
                }
            )
    }
};